import Body from '../Body/Body';
import InfoModuleHeader from './InfoModuleHeader';
import Program from './Program';
import SignupComponent from './SignupComponent';
import { RichText } from '@valbuild/next';

interface InfoModuleProps {
  program?: {
    time?: string;
    description?: string;
  }[];

  date: Date;
  location: {
    nameOfLocation?: string;
    address?: RichText<{
      h1: true;
      h2: true;
      h3: true;
      h4: true;
      h5: true;
      h6: true;
      ul: true;
      ol: true;
      a: true;
      img: true;
      bold: true;
      italic: true;
      lineThrough: true;
    }>;
  };
  eventUrl?: string;
  signupOpen?: boolean;
  signupOpens?: Date;
  eventFull: boolean;
  typeformId?: string;
}

const InfoModule = ({
  program,
  location,
  eventUrl,
  date,
  signupOpen,
  signupOpens,
  eventFull,
  typeformId,
}: InfoModuleProps) => {
  return (
    <div className="flex flex-col tablet:flex-row laptop:flex-col laptop:w-[388px] bg-blank-black">
      <div className="flex flex-col w-full pb-[24px]">
        <div className="flex flex-col pt-0 tablet:pt-0 laptop:pt-[24px] desktop:pt-[24px] laptop:px-[24px] desktop:px-[24px] pb-0 text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px]">
          <InfoModuleHeader header={'NÅR?'} />
          <p>
            {date.toLocaleDateString('nb-NO', {
              year: 'numeric',
              month: 'long',
              day: '2-digit',
              timeZone: 'Europe/Oslo',
            })}
            , kl{' '}
            {date.toLocaleTimeString('nb-NO', {
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'Europe/Oslo',
            })}
          </p>
        </div>
        <div className="flex flex-col gap-[10px] pt-[24px] pb-[48px] laptop:px-[24px] desktop:px-[24px]">
          <InfoModuleHeader header="HVOR?" />
          <div className=" text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px]">
            <p>{location.nameOfLocation}</p>
            <Body
              richText={location.address}
              className="text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px] "
            />
          </div>
        </div>
        {signupOpens && signupOpen && eventUrl && (
          <SignupComponent
            eventDate={date}
            signupOpens={signupOpens}
            signupOpen={signupOpen}
            signupLink={eventUrl}
            eventFull={eventFull}
            typeformId={typeformId}
          />
        )}
      </div>
      <Program program={program} />
    </div>
  );
};
export default InfoModule;
